import React, { CSSProperties, useState } from 'react';
import { Popover } from 'react-tiny-popover';

// This component is for experimenting with UI modifications in
// Storybook, and is not intended for production use. It allows us
// to step by step develop the UI for popout behavior in the
// new right click menu. If
// it becomes permanent, it will have a different parameter set;
// current params are for keeping a number of Storybook stories around
// for testing.

interface PopoutTargetViewProps {
    textToDisplay?: string;
    isCustom?: boolean;
    customTarget?: React.ReactElement;
    customPopoverContent?: React.ReactElement;
}

interface CustomComponentProps extends React.ComponentPropsWithoutRef<'div'> {
    onClick(): void;
}

const CustomComponent = React.forwardRef<HTMLDivElement, CustomComponentProps>((props, ref) => (
    <div ref={ref} onClick={props.onClick} style={props.style}>
        {props.children}
    </div>
));

export const PopoutTargetView = ({ textToDisplay, isCustom, customTarget, customPopoverContent }: PopoutTargetViewProps) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const customPassedIn = isCustom && customTarget && customPopoverContent;

    const handleClickInPopover = () => {
        setIsPopoverOpen(!isPopoverOpen);
    };

    if (customPassedIn) {
        return (
            <Popover
                isOpen={isPopoverOpen}
                content={customPopoverContent}
                positions={['bottom']}
                padding={20}
                reposition={false}
                onClickOutside={() => setIsPopoverOpen(false)}
            >
                {React.cloneElement(customTarget, { onClick: () => setIsPopoverOpen(!isPopoverOpen) })}
            </Popover>
        );
    }

    if (isCustom) {
        return (
            <div>
                <Popover
                    isOpen={isPopoverOpen}
                    content={<div>hey from custom popover content</div>}
                    positions={['bottom']}
                    padding={20}
                    reposition={false}
                >
                    <CustomComponent onClick={() => setIsPopoverOpen(!isPopoverOpen)}>Custom Target</CustomComponent>
                </Popover>
            </div>
        );
    }

    return (
        <Popover
            isOpen={isPopoverOpen}
            positions={['bottom']}
            padding={10}
            reposition={false}
            onClickOutside={() => setIsPopoverOpen(false)}
            content={({ position, nudgedLeft, nudgedTop }) => (
                <div>
                    <div>Hi! I'm popover content. Here's my current position: {position}.</div>
                    <div>I'm {` ${nudgedLeft} `} pixels beyond my boundary horizontally!</div>
                    <div>I'm {` ${nudgedTop} `} pixels beyond my boundary vertically!</div>
                </div>
            )}
        >
            <div onClick={() => handleClickInPopover()} style={{ fontWeight: 'bold', color: 'white' }}>
                {textToDisplay || 'Click me!'}
            </div>
        </Popover>
    );
};
